import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const alertsSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.alerts;
  }
);
